import { useEffect } from "react";

export default function useRequiredReset() {
  useEffect(() => {
    sessionStorage.clear();
  }, []);
}
